export default "__VITE_ASSET__iqvj27AC__"